import ApiService from "./api.service";
export default class ZoneService extends ApiService {
    static base_url = `${super.base_url}/zones`;
}
